import {
  mapSemanticSearchError,
  type SemanticSearchErrorKind,
} from "@/api/utils/semantic-search-error";
import { mapTalentPoolError, type TalentPoolErrorKind } from "./errors";

export type TalentPoolMatchErrorKind =
  | TalentPoolErrorKind
  | Exclude<SemanticSearchErrorKind, { kind: "generic" }>;

export const mapTalentPoolMatchError = (
  error: unknown,
): TalentPoolMatchErrorKind => {
  const semantic = mapSemanticSearchError(error);
  if (semantic.kind !== "generic") return semantic;
  return mapTalentPoolError(error);
};
